import * as React from 'react';
import { PopularSearches } from './SearchHeaderBlocks/PopularSearches';
import { useSearchHeader } from '@src/contexts/SearchHeaderContext';

interface PopularSearchesBlockProps {
  settings?: {
    popular_searches_title?: string;
    popular_searches_list?: string;
    [key: string]: any;
  };
  className?: string;
}

export const PopularSearchesBlock: React.FC<PopularSearchesBlockProps> = ({ settings, className = '' }) => {
  const { collections, suggestedQueries } = useSearchHeader();

  const blockSettings = settings?.settings?.block_settings || settings || {};

  const popularSearches = blockSettings.popular_searches_list?.split(',').map((s) => s.trim()) || [];

  const handlePopularSearchClick = (search: string) => {
    window.location.href = `/search?q=${encodeURIComponent(search)}`;
  };

  // Check if there are search results (collections or suggested queries)
  const hasCollectionResults = collections && collections.length > 0;
  const hasSuggestedQueryResults = suggestedQueries && suggestedQueries.length > 0;

  return (
    <div className={`w-full ${className}`}>
      <PopularSearches
        title={blockSettings.popular_searches_title || 'Popular searches'}
        searches={popularSearches}
        onSearchClick={handlePopularSearchClick}
        hasCollectionResults={hasCollectionResults}
        hasSuggestedQueryResults={hasSuggestedQueryResults}
      />
    </div>
  );
};
